interface ToastItem {
    id: number;
    message: string;
    type: 'success' | 'error';
    leaving: boolean;
}

let toasts = $state<ToastItem[]>([]);
let nextId = 0;

export function addToast(message: string, type: 'success' | 'error'): void {
    const id = nextId++;
    toasts = [...toasts, { id, message, type, leaving: false }];
    setTimeout(() => dismiss(id), 4000);
}

export function dismiss(id: number): void {
    toasts = toasts.map(t => t.id === id ? { ...t, leaving: true } : t);
    setTimeout(() => {
        toasts = toasts.filter(t => t.id !== id);
    }, 300);
}

export function getToasts(): ToastItem[] {
    return toasts;
}
